import {
    isValidElement,
    type ReactNode,
    Children
} from "react";
import type {
    PopoverContentFooterActionsConstantType,
    PopoverContentSheetActionsType,
    PopoverContentSplitType
} from "./type";
import type IButtonProps from "../../../button/type";
import type {
    PopoverFooterActionType
} from "../../type";
import type IPopoverFooterProps from "../footer/type";
import PopoverFooter from "../footer";
import PopoverClose from "../close";

type PopoverContentActionEntryType = {
    action: PopoverFooterActionType;
    isPrimary: boolean;
};

export const splitPopoverContentChildren = (children: ReactNode): PopoverContentSplitType => {
    const split: PopoverContentSplitType = {
        footers: [],
        body: []
    };

    Children.toArray(children).forEach((node) => {
        if(isValidElement<IPopoverFooterProps>(node) && node.type === PopoverFooter) {
            split.footers.push(node);

            return;
        }

        split.body.push(node);
    });

    return split;
};

export const getPopoverContentFooterActions = ({
    footerAlign,
    footerNodes,
    onClose
}: PopoverContentFooterActionsConstantType): PopoverContentSheetActionsType => {
    const entries: Array<PopoverContentActionEntryType> = [];

    Children.toArray(footerNodes).forEach((node) => {
        if(!isValidElement<{ children?: ReactNode; }>(node)) {
            return;
        }

        const isClose = node.type === PopoverClose;

        const button = isClose ? node.props.children : node;

        if(!isValidElement<IButtonProps>(button) || !button.props.title) {
            return;
        }

        entries.push({
            isPrimary: button.props.variant === undefined || button.props.variant === "filled",
            action: {
                accessibilityLabel: button.props.accessibilityLabel,
                isDisabled: button.props.isDisabled,
                isLoading: button.props.isLoading,
                onPress: () => {
                    button.props.onPress();

                    if(isClose) {
                        onClose();
                    }
                },
                title: button.props.title
            }
        });
    });

    const primaryEntry = [
        ...entries
    ].reverse().find((entry) => entry.isPrimary);

    const secondaryEntry = footerAlign === "between" ? entries.find((entry) => entry !== primaryEntry) : undefined;

    return {
        primaryAction: primaryEntry?.action,
        action: secondaryEntry?.action
    };
};
